export enum EModalActions {
  CLOSE_MODAL = 'CLOSE_MODAL',
	ADD_MODAL = 'ADD_WORKER_MODAL',
}

export enum ESortTypes {
  DESC = 'desc',
  ASC = 'asc'
}